<select class="mdb-select md-form" [className]="selectClasses" searchable="Search..." #select></select>
<label class="mdb-main-label" [className]="labelClasses">{{label}}</label>